import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './RecuperarSenha.module.css';
import logo from '../assets/images/logo_old.png';
import styles_content from "./css/main-content.module.css";

function RecuperarSenha() {
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const BASE_URL = process.env.REACT_APP_BACKEND_URL;

    const handleCpfCnpjChange = (e) => {
        setCpfCnpj(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                setError(null);
            }, 30000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${BASE_URL}/hello-sol/recuperar-senha`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    cpfCnpj: cpfCnpj,
                    email: email,
                }),
            });

            if (response.ok) {
                // Tenta converter a resposta para JSON, caso tenha conteúdo
                const data = await response.json().catch(() => null); // Trata resposta vazia
                if (data && data.message) {
                    setMessage(data.message); // Exibe a mensagem enviada pelo backend
                } else {
                    setMessage('Um link de recuperação foi enviado para o seu e-mail.');
                }
                setError(null);
                setCpfCnpj('');
                setEmail('');
            } else {
                const errorData = await response.json().catch(() => null);
                throw new Error(errorData?.message || 'Erro ao enviar solicitação de recuperação.');
            }
        } catch (error) {
            console.error('Erro ao fazer a requisição:', error.message);
            setError(error.message);
            setMessage(null);
        }
    };


    return (
        <div className={styles.recuperarSenhaContainer}>
            <div className={styles.recuperarSenhaContent}>
                <div className={styles.recuperarSenhaLogoContainer}>
                    <a href="/">
                        <img src={logo} alt="Hello Sol" />
                    </a>
                </div>
                <h2>Recuperar Senha</h2>
                {message && <p className={styles.successMessage}>{message}</p>}
                {error && <p className={styles.errorMessage}>{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div>
                        <input
                            type="text"
                            value={cpfCnpj}
                            onChange={handleCpfCnpjChange}
                            placeholder="CPF/CNPJ"
                            maxLength="14"
                        />
                    </div>
                    <div>
                        <input
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            placeholder="E-mail"
                        />
                    </div>
                    <button type="submit" className={styles_content.buttonGroup}>
                        Enviar
                    </button>
                </form>
            </div>
        </div>
    );
}

export default RecuperarSenha;
